import { useHomeBalanceContext } from '@src/Providers/GCashHomeBalanceContext';
import { toBigWithDefault, useWLOrderFormSelector } from '@talos/kyoko';
import { InlineFormattedNumber } from './InlineFormattedNumber';
import { WalletFlowButtons } from './WalletFlowButtons';

export function PortfolioHUD() {
  const favoredPairCurrency = useWLOrderFormSelector(state => state.swap.referenceData.favoredPairCurrency);
  const { displayCurrencyBalance } = useHomeBalanceContext();
  const showBlankScreen = toBigWithDefault(displayCurrencyBalance, 0).eq(0);

  return (
    <div className="w-full">
      <div className="bg-color-bg-main border-color-border shadow-depth-0 flex flex-1 flex-col rounded-md border px-4 py-6">
        <div className="mb-2 flex flex-col gap-1">
          <span className="text-color-text-weakest text-sm uppercase">Portfolio Value</span>
          {showBlankScreen ? (
            <>
              <h1 className="text-color-text text-4xl font-bold">Get started!</h1>
              <h5 className="text-l text-color-text-weakest">Buy {favoredPairCurrency?.Symbol} to start trading.</h5>
            </>
          ) : (
            <>
              <h1 className="text-color-text text-4xl font-bold" data-testid="portfolio-value">
                <InlineFormattedNumber
                  number={displayCurrencyBalance}
                  currency={favoredPairCurrency?.Symbol}
                  increment="0.01"
                />
              </h1>
            </>
          )}
        </div>
        <WalletFlowButtons renderWithdrawal={!showBlankScreen} />
      </div>
    </div>
  );
}
